import axios from "axios";
import { server, config } from "../env";

class ApiRequests {
  async getAccess() {
    var data = {};
    await axios
      .get(server + "/v1/auth/access", config)
      .then((rsp) => {
        data = rsp.data.payload;
      })
      .catch((err) => {});

    return data;
  }

  async regenerateKey() {
    var data = {};
    await axios
      .post(server + "/v1/user/generate-api-key", {}, config)
      .then(async (rsp) => {
        data = await this.getAccess();
      })
      .catch((err) => {});

    return data;
  }
}

export default new ApiRequests();
